import { Company, Permission, ProductTier, User, UserMode } from '../../lib';

type PermissionsProps = {
	[key: string]: (props: { user?: User; company?: Company }) => boolean;
};

export const PermissionValidations: PermissionsProps = {
	// Achieve-related validations. We're going to try to keep this really
	// simple right now. Achieve features know they're achieve features, so
	// maybe we can just get away with one permission check.
	[Permission.CanAccessAchieve]: ({ company }) => company?.product_tier === ProductTier.TierThree && !company?.limited_release_mode,

	// home related validations
	[Permission.CanGiveRecognition]: ({ company, user }) =>
		// NOTE: can_give is true if company allows non-zero giving OR if user mode is normal, benefactor or bot
		user?.can_give === true && company?.product_tier !== ProductTier.TierOne,

	[Permission.CanAccessUserProfile]: ({ company }) => company?.product_tier !== ProductTier.TierOne,

	[Permission.CanAccessAnnouncements]: ({ user }) => user?.global_admin === true || user?.announcements_admin === true,

	[Permission.CanAccessAnalytics]: ({ company }) => company?.product_tier !== ProductTier.TierOne,

	[Permission.CanAccessAdminOnlySettings]: ({ company }) => company?.product_tier !== ProductTier.TierOne,

	[Permission.CanViewStrongerConnections]: ({ company }) => company?.product_tier !== ProductTier.TierOne,

	[Permission.CanViewManagerGiving]: ({ company }) => company?.product_tier !== ProductTier.TierOne,

	// right sidebar related validations
	[Permission.CanViewHashtagSummary]: ({ company }) => company?.product_tier !== ProductTier.TierOne,

	[Permission.CanViewUserSummary]: ({ company }) => company?.product_tier !== ProductTier.TierOne && !company?.hide_competitive_features,

	// reward related validations
	[Permission.CanClaimPointsBoost]: ({ company, user }) =>
		user?.user_mode !== UserMode.Observer && user?.user_mode !== UserMode.Receiver && company?.product_tier !== ProductTier.TierOne,

	// admin related validations
	[Permission.CanViewAdmin]: ({ user }) =>
		!!user?.admin || !!user?.global_admin || !!user?.awards_admin || !!user?.rewards_admin || !!user?.finance_admin || !!user?.tech_admin,

	[Permission.CanManageAwards]: ({ user }) => !!user?.admin || !!user?.global_admin || !!user?.awards_admin,

	// can manage show departments on analytics leaderboard checkbox > tier 1
	[Permission.CanManageShowDepartmentsOnLeaderboard]: ({ company }) => company?.product_tier !== ProductTier.TierOne,

	[Permission.CanManagePointsBoost]: ({ company }) => company?.product_tier !== ProductTier.TierOne,

	// super admin related validation
	[Permission.CanViewSuperAdmin]: ({ user }) => !!user?.show_superadmin_feature,

	// admin programs validations
	[Permission.CanManagePeerToPeer]: ({ company }) => company?.product_tier !== ProductTier.TierOne,

	[Permission.CanManageAllAnnouncements]: ({ user }) => user?.global_admin === true,

	// video related validations
	[Permission.CanManageVideoUploads]: ({ company }) => !company?.disable_video_uploads,
	[Permission.CanRecordVideo]: ({ company }) =>
		// If the company has allowed video uploading OR recording
		(!company?.disable_video_recordings || !company?.disable_video_uploads) &&
		// And they're not on the Appreciate package
		company?.product_tier !== ProductTier.TierOne,
};
